import { useState, useEffect } from 'react';

const useAuthContext = () => {
  const [authState, setState] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const jUser = localStorage.getItem('@director/usr');
    const token = localStorage.getItem('@director/tkn');
    if (token) {
      setState({
        user: jUser ? JSON.parse(jUser) : null,
        token
      });
    }
    setLoading(false);
  }, []);

  const handleLogin = async (basicToken) => {
    const headers = { Authorization: `Basic ${basicToken}` };
    const response = await fetch('/api/auth', { headers });
    const data = await response.json();

    if (data.sucesso) {
      const tokenValue = atob(basicToken);
      const domain = tokenValue.split('|')[0];
      const { codEmpresa, id, usuario, empresa, token } = data.dados;
      const user = {codEmpresa,id,usuario,empresa};
      localStorage.setItem('@director/tkn', token);
      localStorage.setItem('@director/usr', JSON.stringify(user));
      sessionStorage.setItem('@director/domain',domain);
      setState({ user, token });
    }

    return data;
  };

  const handleLogout = () => {
    setState({ user: null, token: null });
    localStorage.removeItem('@director/usr');
    localStorage.removeItem('@director/tkn');
    localStorage.removeItem('@director/tabs');
    localStorage.removeItem('@director/configs');
    sessionStorage.removeItem('@director/acl');
    sessionStorage.removeItem('@director/appMenu');
    sessionStorage.removeItem('@director/userguid');
    sessionStorage.removeItem('@director/domain');

    let appconfigs = sessionStorage.getItem('@director/appconfigs');
    if (appconfigs) {
      appconfigs = JSON.parse(appconfigs);

      window.location.href = appconfigs.urlPortalDirector
        ? appconfigs.urlPortalDirector
        : '';

      sessionStorage.removeItem('@director/appconfigs');
    } else {
      window.location.href = '/';
    }
  };

  return { authState, loading, handleLogin, handleLogout };
};

export default useAuthContext;
